import React from 'react';
import { useHistory } from 'react-router-dom';
import { getActivePermitedPath, getUserPermissions, userHavePermission } from "~/Services/Helpers";
import { useUserContext } from "~/Services/Providers";
import { MenuTile } from '../../';
import useStyles from './styles';

const MainMenu = ({ data, setActive, handleDrawerToggle, activeNav }) => {
    const history = useHistory();
    const classes = useStyles();
    const { userContextObj } = useUserContext();
    const permissions = getUserPermissions(userContextObj.role);
    const Menu = () => (
        <div>
            {
                Object.keys(data).map((key, index) => {
                    const activePath = getActivePermitedPath(permissions, data[key]);
                    return userHavePermission(permissions, ...data[key].permissions) ?
                        <MenuTile
                            key={index}
                            element={data[key]}
                            icon={data[key].icon}
                            active={activeNav.activeTile === key}
                            handleClick={() => {
                                if (data[key]?.sections?.length > 0) handleDrawerToggle(true);
                                else handleDrawerToggle(false);
                                setActive({ activeTile: key, path: activePath })
                                history.push(activePath)
                            }}
                        /> : <></>
                })

            }
        </div>
    );

    return <Menu />
}

export default MainMenu;